export default {
  ERROR_COLOR: '#D21726',
  TEST_RIDE_THEME: '#8E817A',
  DISABLED: '#E5E5E5'
};
